"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = template;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _alert = _interopRequireDefault(require("../../style/alert"));

var _react = _interopRequireDefault(require("react"));

var _l10n = _interopRequireDefault(require("../../../../common/l10n"));

var _Button = _interopRequireDefault(require("../../../Button"));

var _createStyled = _interopRequireDefault(require("../../../../utils/createStyled"));

function _templateObject2() {
  var data = (0, _taggedTemplateLiteral2["default"])([""]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2["default"])([""]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var Div = _createStyled["default"].div(_templateObject()),
    Form = _createStyled["default"].form(_templateObject2());

function template() {
  var titleContent = null;
  var _this$props = this.props,
      needTitle = _this$props.needTitle,
      title = _this$props.title,
      buttonLabel = _this$props.buttonLabel,
      children = _this$props.children,
      _this$props$className = _this$props.className,
      className = _this$props$className === void 0 ? '' : _this$props$className,
      _this$props$style = _this$props.style,
      style = _this$props$style === void 0 ? {} : _this$props$style,
      styles = this.compileStyled(_alert["default"]);

  if (needTitle) {
    titleContent = _react["default"].createElement(Div, {
      styles: styles.title
    }, _l10n["default"].translate(title));
  }

  return _react["default"].createElement(Form, {
    action: "/",
    method: "post",
    className: className,
    onSubmit: this.submit,
    styles: styles.root
  }, titleContent, _react["default"].createElement(Div, {
    styles: styles.content
  }, children), _react["default"].createElement(Div, {
    styles: styles.controls
  }, _react["default"].createElement(Div, {
    styles: styles.button
  }, _react["default"].createElement(_Button["default"], {
    primary: true,
    type: "submit",
    style: style.button,
    "data-qa-node": "popup-alert-button",
    "data-qa-value": "submit"
  }, _l10n["default"].translate(buttonLabel)))));
}